import { takeLatest, put, all, call } from 'redux-saga/effects';
import { salesAdjustmentAPI } from 'resources/api';
import Types from './types';
import { goBack } from 'connected-react-router';
import { processError } from 'state/utils';

function* fetchStartAsync({payload}) {
  try {
    const res = yield salesAdjustmentAPI.getAll(payload);
    yield put({ type: Types.FETCH_SUCCESS, payload: res });
  } catch (error) {
    const message = processError(error);
    console.error(message);
    yield put({ type: Types.FETCH_ERROR, payload: message });
  }
}

function* fetchStart() {
  yield takeLatest(Types.FETCH_START, fetchStartAsync);
}

function* updateStartAsync({ payload }) {
  try {
    yield salesAdjustmentAPI.updateBulk(payload);
    yield put({ type: Types.UPDATE_SUCCESS, payload });
    yield put(goBack());
  } catch (error) {
    const message = processError(error);
    console.error(message);
    yield put({ type: Types.UPDATE_ERROR, payload: message });
  }
}

function* updateStart() {
  yield takeLatest(Types.UPDATE_START, updateStartAsync);
}

function* createStartAsync({ payload }) {
  try {
    yield salesAdjustmentAPI.createBulk(payload);
    yield put({ type: Types.CREATE_SUCCESS, payload });
    yield put({ type: Types.FETCH_START, payload: payload.sale.groupId});
    yield put(goBack());
  } catch (error) {
    const message = processError(error);
    console.error(message);
    yield put({ type: Types.CREATE_ERROR, payload: message });
  }
}

function* createStart() {
  yield takeLatest(Types.CREATE_START, createStartAsync);
}

function* deleteStartAsync({ payload }) {
  try {
    yield salesAdjustmentAPI.delete(payload);
    yield put({ type: Types.DELETE_SUCCESS, payload });
  } catch (error) {
    const message = processError(error);
    console.error(message);
    yield put({ type: Types.DELETE_ERROR, payload: message });
  }
}

function* deleteStart() {
  yield takeLatest(Types.DELETE_START, deleteStartAsync);
}

export default function* sagas() {
  yield all([call(fetchStart), call(updateStart), call(createStart), call(deleteStart)]);
}
